import React, { useEffect, useRef, useState } from 'react';

const AnimatedText = ({ 
  children, 
  className = '', 
  delay = 0, 
  duration = 0.8,
  isTitle = false,
  isH1 = false 
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            setIsVisible(true);
          }, delay);
        }
      },
      { threshold: 0.1 }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => observer.disconnect();
  }, [delay]);

  // Use Lostar for H1, Amoria for other titles, Montserrat for body
  const baseClasses = isH1 ? 'font-lostar' : (isTitle ? 'font-amoria' : 'font-montserrat');
  const animationClasses = isVisible 
    ? 'opacity-100 translate-y-0' 
    : 'opacity-0 translate-y-8';

  return (
    <div
      ref={ref}
      className={`${baseClasses} ${animationClasses} transition-all ease-out ${className}`}
      style={{ 
        transitionDuration: `${duration}s`,
        transitionDelay: `${delay}ms`
      }}
    >
      {children}
    </div>
  );
};

export default AnimatedText;